export default __webpack_public_path__ + "static/media/image-upload.3cad36f5.svg";